import { ChangeDetectorRef, Component, OnChanges, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSelect, MatOption, MatTab } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { QUALITYMATRIXINCIDENTDATA } from '../common/constants/labels';
import { ClusterSiteBigCategoryData } from '../common/models/ClusterFactory';
import { CurrencyList, IncidentData } from '../common/models/incident-dashboard-filterparameterdata';
import { IncidentDataFilterparameterViewModel, InicedentData } from '../common/models/incident-data-filterparameter';
import { Role } from '../common/models/role';
import { AuthenticationService } from '../common/services/authentication.service';
import { DashboardSqlService } from '../dashboard-sql/dashboard-sql.service';
import { IncidentUploadSqlService } from '../incident-upload-SQL/incident-upload-sql.service';
import { QualityMatrixDataService } from './quality-matrix-data.service';

@Component({
  selector: 'app-quality-matrix-data',
  templateUrl: './quality-matrix-data.component.html',
  styleUrls: ['./quality-matrix-data.component.scss']
})
export class QualityMatrixDataComponent implements OnInit, OnChanges {
  title = '';
  incidentDataCol = QUALITYMATRIXINCIDENTDATA;
  currencyList: Array<CurrencyList> = [];
  formValidationMsg: string;
  showFormValidation: boolean;
  loading: boolean;
  clustersitebigcategoryArray: Array<ClusterSiteBigCategoryData> = [];
  cluster: any;
  sites: string[];
  clusterdefault = '';
  sitedefault = '';
  bigcategorydefault = '';
  currencydefault = '';
  yeardefault: number;
  pickedyear: number;
  bigcategoryU: string[];
  role: any;
  disableSite: boolean;
  disableCluster: boolean;
  currencies: any[];

  incidentDataForm = new FormGroup({
    yearcontrol: new FormControl(),
    clusters: new FormControl(),
    sites: new FormControl(),
    bigcategories: new FormControl(),
    currency: new FormControl()
  });

  @ViewChild('clusterControl', {static: false}) clusterControl: MatSelect;
  @ViewChild('siteControl', {static: false}) siteControl: MatSelect;
  @ViewChild('bigCategoryControl', {static: false}) bigCategoryControl: MatSelect;

  @ViewChild('clusterFilter', {static: false}) clusterFilterControl: MatSelect;
  @ViewChild('siteFilter', {static: false}) siteFiltercontrol: MatSelect;
  @ViewChild('bigCategoryFilter', {static: false}) bigCategoryFilterControl: MatSelect;
  showSuccess: boolean;
  disableGetDataButton: boolean;
  yearSelect: any[];
  ValidationMsg: string;
  showValidationMessage: boolean;
  bigcategory: string[];
  siteAllSelected: boolean;
  site: string[];
  clustertooltip = [];
  sitetooltip = [];
  bigcategorytooltip = [];
  allSelected: boolean;
  bigCategoryAllSelected: boolean;
  dataAvailable: boolean;
  noRecordsShow = true;
  noRecords: string;
  nofiltereddata: boolean;
  bigCategoryFilterSelectedAll = false;
  userFilterSelectedAll = false;
  siteFilterSelectedAll = false;
  clusterFilterSelectedAll = false;
  disableBtnGetData: boolean;
  filterParameterForIncidentData: IncidentDataFilterparameterViewModel;
  incidentDataSource = [];
  @ViewChild('paginator', {static: false}) paginator!: MatPaginator;
  dataSource!: MatTableDataSource<IncidentData>;

  constructor(private incidentservice: IncidentUploadSqlService, private dashboardsqlservice: DashboardSqlService, private authenticateService: AuthenticationService, private qmDataService: QualityMatrixDataService, private cdr: ChangeDetectorRef) {
    this.title = 'Incidents Data';
  }
  ngOnChanges() {
    this.title = 'Data - ' + this.pickedyear;
  }
  ngOnInit() {
    this.loading = true;
    this.setYear();
    this.getCurrencyList();
    this.getClusterSiteBigCategoryData();
    this.cdr.detectChanges();
  }
  setYear() {
    const currentYear = new Date().getFullYear();
    let currentYearIndex = 0;
    let index = 0;
    this.yearSelect = [];
    for (let i = 2020; i <= currentYear; i++) {
      this.yearSelect.push(i);
      index++;
      if (i === currentYear) {
        currentYearIndex = index;
        this.yeardefault = currentYear;
        this.pickedyear = currentYear;
      }

    }
    this.incidentDataForm.controls['yearcontrol'].setValue(this.yearSelect[currentYearIndex - 1]);
  }

  getCurrencyList() {
    this.incidentservice.getCurrency().subscribe((response) => {
      if (response.length > 0) {
        const currencyArray = [];
        response.forEach((e) => {
          let object = {};
          object = {
            currencyunit: e.currencyunit,
            site: e.site,
            currencycode: e.currencycode
          };
          currencyArray.push(object);
        });
        this.currencyList = currencyArray;
      }
    });
  }

  getClusterSiteBigCategoryData() {
    this.dashboardsqlservice.getClusterFactoryData().subscribe((response) => {
      if (response.length === 0) {
        this.ValidationMsg = 'Failed to get the cluster, site and Bigcategory. Please try after sometime.';
        this.showFormValidation = true;
        this.loading = false;
      } else {
        response.forEach((e) => {
          let object: ClusterSiteBigCategoryData;
          object = {
            subregion: e.subregion,
            site: e.site,
            businessgroup: e.businessgroup,
            factoryname: e.factoryname
          };
          this.clustersitebigcategoryArray.push(object);
        });
        this.cluster = this.clustersitebigcategoryArray.map(item => item.subregion).filter((value, index, self) => self.indexOf(value) === index).sort();
        this.selectClusterSiteDropdownwithdefault();
      }
    }, (error) => {
      this.ValidationMsg = 'Failed to get the cluster, site and Bigcategory. Please try after sometime.';
      this.showFormValidation = true;
      this.loading = false;
    });
  }

  loadSite() {
    this.disableBtnGetData = true;
    this.bigcategoryU = [];
    this.currencies = [];
    this.sites = [];
    const tempArray: string[] = [];
    this.incidentDataForm.get('sites').setValue(null);
    let clusterSelected = '';
    this.showSuccess = false;
    this.ValidationMsg = '';
    if (this.incidentDataForm.get('clusters').value.length > 0) {
      clusterSelected = this.incidentDataForm.get('clusters').value;
      this.clustersitebigcategoryArray.forEach(element => {
        if (clusterSelected === element.subregion) {
          tempArray.push(element.site);
        }
      });
      this.sites = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
    }
  }

  loadBigCategory() {
    this.bigcategoryU = [];
    this.currencies = [];
    this.incidentDataForm.get('bigcategories').setValue(null);
    let siteSelected = '';
    const tempArray: string[] = [];
    this.showSuccess = false;
    this.showFormValidation = false;
    if (this.incidentDataForm.get('sites').value.length > 0) {
      siteSelected = this.incidentDataForm.get('sites').value;
      this.clustersitebigcategoryArray.forEach(element => {
        if (siteSelected === element.site) {
          tempArray.push(element.businessgroup);
        }
      });
      this.bigcategoryU = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
    }
    if (this.incidentDataForm.get('bigcategories').value === null) {
      this.disableBtnGetData = true;
    } else {
      this.disableBtnGetData = false;
    }
  }

  setIncidentDataFormDefault() {
    if (this.incidentDataForm.get('clusters').value === null && (this.clusterdefault !== null || this.clusterdefault !== '')) {
      this.incidentDataForm.controls['clusters'].setValue(this.clusterdefault);
    }
    if (this.incidentDataForm.get('sites').value === null && (this.sitedefault !== null || this.sitedefault !== '')) {
      this.incidentDataForm.controls['sites'].setValue(this.sitedefault);
    }
    if (this.incidentDataForm.get('bigcategories').value === null && (this.bigcategorydefault !== null || this.bigcategorydefault !== '')) {
      this.incidentDataForm.controls['bigcategories'].setValue(this.bigcategorydefault);
    }
    if (this.incidentDataForm.get('currency').value === null && (this.currencydefault !== null || this.currencydefault !== '')) {
      this.incidentDataForm.controls['currency'].setValue(this.currencydefault);
    }
    if (this.incidentDataForm.get('yearcontrol').value === null && this.yeardefault !== 0) {
      this.incidentDataForm.controls['yearcontrol'].setValue(this.yeardefault);
    }
  }

  selectClusterSiteDropdownwithdefault() {
    this.loading = true;
    let factory = '';
    factory = localStorage.getItem('factory');
    this.role = localStorage.getItem('role');
    const tempArray: string[] = [];
    this.clustersitebigcategoryArray.forEach(clusterfilter => {
      if (clusterfilter.factoryname === factory || this.authenticateService.findSiteNameInFactoryName(factory, clusterfilter.site)) {
        this.clusterdefault = clusterfilter.subregion;
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterfilter.subregion === element.subregion) {
            tempArray.push(element.site);
          }
        });
        this.sites = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
        this.sitedefault = clusterfilter.site;
        this.bigcategorydefault = clusterfilter.businessgroup;
        const currencyArr = this.currencyList.filter((c) => clusterfilter.site.toLowerCase() === c.site.toLowerCase() || c.site.startsWith(clusterfilter.site));
        const currencyArrayDistinct = [];
        currencyArr.forEach(x => {
          currencyArrayDistinct.push(x.currencyunit);
        });
        this.currencies = currencyArrayDistinct.map(item => item).filter((value, index, self) => self.indexOf(value) === index);
        const val = this.currencies.filter(X => X === 'Euro');
        if (val.length === 0) {
          this.currencies.push('Euro');
        }
        this.currencydefault = this.currencies[0];
        const bigArray: string[] = [];
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterfilter.site === element.site) {
            bigArray.push(element.businessgroup);
          }
        });
        this.bigcategoryU = bigArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
        if (this.role === Role.qualityChampion) {
          this.disableSite = false;
          this.disableCluster = true;
        } else if (this.role === Role.globalAdmin) {
          this.disableSite = false;
          this.disableCluster = false;
        } else {
          this.disableSite = true;
          this.disableCluster = true;
          this.setIncidentDataFormDefault();
        }
        this.getQualityMatrixData();
        this.loading = false;
      }
    });
    if (this.clusterdefault === '') {
      const clusterdata = [];
      this.loading = true;
      const clusterBasedOnRole = localStorage.getItem('clusterBasedOnRole');
      let clusterBasedOnRoleparsed = [];
      if (clusterBasedOnRole !== null && clusterBasedOnRole !== undefined) {
        clusterBasedOnRoleparsed = JSON.parse(clusterBasedOnRole);
        this.clusterdefault = clusterBasedOnRoleparsed[0];
        this.clustersitebigcategoryArray.forEach(element => {
          if (clusterBasedOnRoleparsed[0] === element.subregion) {
            tempArray.push(element.site);
          }
        });
        this.sites = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
        this.sitedefault = this.sites[0];
        const currencyArr = this.currencyList.filter((c) => this.sites[0] === c.site || c.site.startsWith(this.sites[0]));
        const currencyArrayDistinct = [];
        currencyArr.forEach(x => {
          currencyArrayDistinct.push(x.currencyunit);
        });
        this.currencies = currencyArrayDistinct.map(item => item).filter((value, index, self) => self.indexOf(value) === index);
        const val = this.currencies.filter(X => X === 'Euro');
        if (val.length === 0) {
          this.currencies.push('Euro');
        }
        this.currencydefault = this.currencies[0];
        const bigArray: string[] = [];
        this.clustersitebigcategoryArray.forEach(element => {
          if (this.sites[0] === element.site) {
            bigArray.push(element.businessgroup);
          }
        });
        this.bigcategoryU = bigArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
        if (this.role === Role.qualityChampion) {
          this.disableSite = false;
          this.disableCluster = true;
        } else if (this.role === Role.globalAdmin) {
          this.disableSite = false;
          this.disableCluster = false;
        } else {
          this.disableSite = true;
          this.disableCluster = true;
          this.setIncidentDataFormDefault();
        }
        this.getQualityMatrixData();
        this.loading = false;
      } else {
        this.dashboardsqlservice.getClusterFromDFOS(this.role).subscribe((response) => {
          if (response !== null) {
            response.forEach(element => {
              clusterdata.push(element.name);
            });
            localStorage.setItem('clusterBasedOnRole', JSON.stringify(clusterdata));
            this.clusterdefault = clusterdata[0];
            this.clustersitebigcategoryArray.forEach(element => {
              if (clusterdata[0] === element.subregion) {
                tempArray.push(element.site);
              }
            });

            this.sites = tempArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();
            this.sitedefault = this.sites[0];
            const currencyArr = this.currencyList.filter((c) => this.sites[0] === c.site || c.site.startsWith(this.sites[0]));
            const currencyArrayDistinct = [];
            currencyArr.forEach(x => {
              currencyArrayDistinct.push(x.currencyunit);
            });
            this.currencies = currencyArrayDistinct.map(item => item).filter((value, index, self) => self.indexOf(value) === index);
            const val = this.currencies.filter(X => X === 'Euro');
            if (val.length === 0) {
              this.currencies.push('Euro');
            }
            this.currencydefault = this.currencies[0];
            const bigArray: string[] = [];
            this.clustersitebigcategoryArray.forEach(element => {
              if (this.sites[0] === element.site) {
                bigArray.push(element.businessgroup);
              }
            });
            this.bigcategoryU = bigArray.map(item => item).filter((value, index, self) => self.indexOf(value) === index).sort();

            if (this.role === Role.qualityChampion) {
              this.disableSite = false;
              this.disableCluster = true;
            } else if (this.role === Role.globalAdmin) {
              this.disableSite = false;
              this.disableCluster = false;
            } else {
              this.disableSite = true;
              this.disableCluster = true;
              this.setIncidentDataFormDefault();
            }
          }
          this.getQualityMatrixData();
          this.loading = false;
        });
      }
    }
  }

  ClearCurrencyOnBigCategorySelect() {
    const siteSelected = this.incidentDataForm.get('sites').value;
    const currencyArr = this.currencyList.filter((c) => siteSelected.toLowerCase() === c.site.toLowerCase() || c.site.startsWith(siteSelected));
    const currencyArrayDistinct = [];
    this.showSuccess = false;
    this.showFormValidation = false;
    currencyArr.forEach(x => {
      currencyArrayDistinct.push(x.currencyunit);
    });
    this.currencies = currencyArrayDistinct.map(item => item).filter((value, index, self) => self.indexOf(value) === index);
    const val = this.currencies.filter(X => X === 'Euro');
    if (val.length === 0) {
      this.currencies.push('Euro');
    }
    this.currencydefault = this.currencies[0];
  }

  EnableGetDataButton() {
    this.showSuccess = false;
    this.showFormValidation = false;
    if (this.incidentDataForm.get('sites').value !== null && this.incidentDataForm.get('clusters').value !== null
      && this.incidentDataForm.get('bigcategories').value !== null && this.incidentDataForm.get('currency').value !== null) {
      this.disableBtnGetData = false;
    }
  }

  clearData() {
    this.pickedyear = this.incidentDataForm.get('yearcontrol').value;
    this.showValidationMessage = false;
    this.showSuccess = false;
    this.dataAvailable = false;
    this.noRecords = '';
    this.nofiltereddata = true;
  }

  getQualityMatrixData() {
    this.loading = true;
    this.showValidationMessage = false;
    this.showSuccess = false;
    this.ValidationMsg = '';
    const selectedcluster = [];
    const selectedsite = [];
    const selectedbigcategory = [];
    const selectedcurrency = [];
    let selectedyear = 0;
    if (this.incidentDataForm.controls['yearcontrol'].value === 0) {
      selectedyear = this.yeardefault;
    } else {
      selectedyear = this.incidentDataForm.controls['yearcontrol'].value;
    }
    if (this.incidentDataForm.get('clusters').value === '' || this.incidentDataForm.get('clusters').value === null) {
      selectedcluster.push(this.clusterdefault);
    } else {
      selectedcluster.push(this.incidentDataForm.get('clusters').value);
    }
    if (this.incidentDataForm.get('sites').value === '' || this.incidentDataForm.get('sites').value === null) {
      selectedsite.push(this.sitedefault);
    } else {
      selectedsite.push(this.incidentDataForm.get('sites').value);
    }
    if (this.incidentDataForm.get('bigcategories').value === '' || this.incidentDataForm.get('bigcategories').value === null) {
      selectedbigcategory.push(this.bigcategorydefault);
    } else {
      selectedbigcategory.push(this.incidentDataForm.get('bigcategories').value);
    }
    if (this.incidentDataForm.get('currency').value === '' || this.incidentDataForm.get('currency').value === null) {
      selectedcurrency.push(this.currencydefault);
    } else {
      selectedcurrency.push(this.incidentDataForm.get('currency').value);
    }

    if (selectedyear !== null && selectedcluster !== null && selectedsite !== null && selectedbigcategory !== null && selectedcurrency !== null) {
      this.filterParameterForIncidentData = {
          cluster: selectedcluster,
          site: selectedsite,
          bigcategory: selectedbigcategory,
          currency: [''],
          year: selectedyear
      };
      this.getIncidentData(this.filterParameterForIncidentData);
    }
  }

  getIncidentDataAny(incidentDataFilterParameterVM: IncidentDataFilterparameterViewModel) {
    this.qmDataService.getIncidentsData(incidentDataFilterParameterVM).subscribe(response => {
      const IncidentDataDetails = [];
      if (response.length === 0) {
        this.noRecordsShow = true;
        this.noRecords = 'No record found for the selected year';
      } else {
        this.noRecords = '';
        this.noRecordsShow = false;
      }

      response.forEach(e => {
        let object = {};
        object = {
          id: e.id,
          incidentfileid: e.incidentfileid,
          productiondate: e.productiondate,
          productcode: e.productcode,
          productdescription: e.productdescription,
          materialtype: e.materialtype === null ? ' -- ' : e.materialtype,
          defectmodeaggregation: e.defectmodeaggregation,
          packagingmateriallevel: e.packagingmateriallevel === null ? ' -- ' : e.packagingmateriallevel,
          cluster: e.cluster,
          bigcategory: e.bigcategory,
          subcategory: e.subcategory,
          product: e.product,
          defecttypecode: e.defecttypecode === null ? ' -- ' : e.defecttypecode,
          formatsize: e.formatsize,
          losstree: e.losstree,
          leveL0: e.leveL0,
          leveL1: e.leveL1,
          leveL2: e.leveL2,
          leveL3: e.leveL3,
          leveL4: e.leveL4,
          leveL5: e.leveL5,
          defectseveritygrade: e.defectseveritygrade,
          productionline: e.productionline,
          noofblockedproduct: e.noofblockedproduct,
          averagebatchqty: e.averagebatchqty,
          uom: e.uom,
          affectedproductpercentage: e.affectedproductpercentage,
          frequencyscore: e.frequencyscore,
          processpoint: e.processpoint,
          fourms: e.fourms,
          detectionpoint: e.detectionpoint,
          detectability: e.detectability,
          eincident: e.eincident,
          rework: e.rework,
          ambercrqs: e.ambercrqs,
          qualityrelatedwaste: e.qualityrelatedwaste,
          dincidents: e.dincidents,
          palletnonconformance: e.palletnonconformance,
          customernonconformance: e.customernonconformance,
          onshelfcrqs: e.onshelfcrqs,
          consumercomplaints: e.consumercomplaints,
          marketplaceincident: e.marketplaceincident,
          costoF1PC: e.costoF1PC,
          totaldefectcost: e.totaldefectcost,
          totalcostpercentage: e.totalcostpercentage,
          costscore: e.costscore,
          detectabilityindex: e.detectabilityindex,
          severityindex: e.severityindex,
          frequencyindex: e.frequencyindex,
          costindex: e.costindex,
          defectpriorityindex: e.defectpriorityindex,
          dpivstotaldpipercentage: e.dpivstotaldpipercentage,
          cummulativedpi: e.cummulativedpi,
          dpidefectclass: e.dpidefectclass,
          man: e.man,
          machine: e.machine,
          method: e.method,
          material: e.material,
          pdcastatus: e.pdcastatus,
          sites: e.sites,
          localcurrency: e.localcurrency,
          totaldefectcosteuro: e.totaldefectcosteuro,
          inserteddate: e.inserteddate,
          insertedby: e.insertedby,
          updateddate: e.updateddate,
          updatedby: e.updatedby,
          updateD_PDCASTATUS: e.updateD_PDCASTATUS,
          lasT_PDCASTATUS_UPDATEDDATE: e.lasT_PDCASTATUS_UPDATEDDATE
        };
        IncidentDataDetails.push(object);
      });
      this.incidentDataSource = IncidentDataDetails;
      this.loading = false;
    });
  }
  getIncidentData(incidentDataFilterParameterVM: IncidentDataFilterparameterViewModel) {
    this.qmDataService.getIncidentsData(incidentDataFilterParameterVM).subscribe(response => {
      const IncidentDataDetails = [];
      if (response.length === 0) {
        this.noRecordsShow = true;
        this.noRecords = 'No record found for the selected year';
      } else {
        this.noRecords = '';
        this.noRecordsShow = false;
      }

      response.forEach(e => {
        let object: {} = IncidentData;
        object = {
          id: e.id,
          incidentfileid: e.incidentfileid,
          productiondate: e.productiondate,
          productcode: e.productcode,
          productdescription: e.productdescription,
          materialtype: e.materialtype === null ? ' -- ' : e.materialtype,
          defectmodeaggregation: e.defectmodeaggregation,
          packagingmateriallevel: e.packagingmateriallevel === null ? ' -- ' : e.packagingmateriallevel,
          cluster: e.cluster,
          bigcategory: e.bigcategory,
          subcategory: e.subcategory,
          recordid: e.recordid,
          defecttypecode: e.defecttypecode === null ? ' -- ' : e.defecttypecode,
          formatsize: e.formatsize,
          losstree: e.losstree,
          leveL0: e.leveL0,
          leveL1: e.leveL1,
          leveL2: e.leveL2,
          leveL3: e.leveL3,
          leveL4: e.leveL4,
          leveL5: e.leveL5,
          defectseveritygrade: e.defectseveritygrade,
          productionline: e.productionline,
          noofblockedproduct: e.noofblockedproduct,
          averagebatchqty: e.averagebatchqty,
          uom: e.uom,
          affectedproductpercentage: e.affectedproductpercentage,
          frequencyscore: e.frequencyscore,
          processpoint: e.processpoint,
          fourms: e.fourms,
          detectionpoint: e.detectionpoint,
          detectability: e.detectability,
          eincident: e.eincident,
          rework: e.rework,
          ambercrqs: e.ambercrqs,
          qualityrelatedwaste: e.qualityrelatedwaste,
          dincidents: e.dincidents,
          palletnonconformance: e.palletnonconformance,
          customernonconformance: e.customernonconformance,
          onshelfcrqs: e.onshelfcrqs,
          consumercomplaints: e.consumercomplaints,
          marketplaceincident: e.marketplaceincident,
          costoF1PC: e.costoF1PC,
          totaldefectcost: e.totaldefectcost,
          totalcostpercentage: e.totalcostpercentage,
          costscore: e.costscore,
          detectabilityindex: e.detectabilityindex,
          severityindex: e.severityindex,
          frequencyindex: e.frequencyindex,
          costindex: e.costindex,
          defectpriorityindex: e.defectpriorityindex,
          dpivstotaldpipercentage: e.dpivstotaldpipercentage,
          cummulativedpi: e.cummulativedpi,
          dpidefectclass: e.dpidefectclass,
          man: e.man,
          machine: e.machine,
          method: e.method,
          material: e.material,
          pdcastatus: e.pdcastatus,
          sites: e.sites,
          localcurrency: e.localcurrency,
          totaldefectcosteuro: e.totaldefectcosteuro,
          inserteddate: e.inserteddate,
          insertedby: e.insertedby,
          updateddate: e.updateddate,
          updatedby: e.updatedby,
          updateD_PDCASTATUS: e.updateD_PDCASTATUS,
          lasT_PDCASTATUS_UPDATEDDATE: e.lasT_PDCASTATUS_UPDATEDDATE
        };
        IncidentDataDetails.push(object);
      });
      this.incidentDataSource = IncidentDataDetails;
      this.dataSource = new MatTableDataSource<IncidentData>(this.incidentDataSource);
      this.dataSource.paginator = this.paginator;
      this.loading = false;
    });
  }
}
